import { FormGroup, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(
	controlName: string,
	matchingControlName: string,
): ValidationErrors | null {
	return (formGroup: FormGroup) => {
		const startDate = formGroup.controls[controlName];
		const endDate: any = formGroup.controls[matchingControlName];

		if (endDate.errors && !endDate.errors.dateRangeValidator) {
			return;
		}

		if (startDate.value && endDate.value) {
			const isRangeValid =
				new Date(endDate.value).getTime() -
					new Date(startDate.value).getTime() >
				0;
			if (!isRangeValid) {
				endDate.setErrors({
					dateRangeValidator: true,
				});
			} else {
				endDate.setErrors(null);
			}
		} else {
			endDate.setErrors(null);
		}
	};
}
